import loadable from '../../../utilities/loadable'

export const SendOTPButton = loadable(() => import('./SendOTPButton'))

export const TwoFactorButton = loadable(() => import('./TwoFactorButton'))
